import * as React from 'react';

const CrossFat = () => (
  <svg width="0.9em" height="0.9em" viewBox="0 0 498 498" fill="none">
    <path
      d="M13 485L485 13M485 485L13 13"
      strokeWidth={70}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default React.memo(CrossFat);
